import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import NavigationHeader from './NavigationHeader';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import BusinessHoursSection from './BusinessHoursSection';
import ServicesSection from './ServicesSection';
import PhotoGallery from './PhotoGallery';
import TestimonialsSection from './TestimonialsSection';
import GMBFeedSection from './GMBFeedSection';
import LocationSection from './LocationSection';
import CategoryTagsSection from './CategoryTagsSection';
import RelatedServicesSection from './RelatedServicesSection';
import Footer from './Footer';

// Modern Google Fonts for Noir Luxe Design
const GoogleFontsLink = () => (
  <link
    href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=Outfit:wght@300;400;500;600;700;800;900&display=swap"
    rel="stylesheet"
  />
);

const TemplateContainer = styled(Box)({
  width: '100%',
  minHeight: '100vh',
  backgroundColor: '#0a0a0f',
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  overflowX: 'hidden',
  color: '#ffffff'
});

const Template9 = ({
  templateData,
  isEditable = false,
  onTemplateUpdate
}) => {
  const {
    businessInfo,
    services,
    products,
    photos,
    testimonials,
    contactInfo,
    location,
    gmbFeed,
    businessHours,
    categories,
    keywordsData
  } = templateData || {};

  const hasBusinessInfo = businessInfo?.name;
  const hasServices = services && services.length > 0;
  const hasProducts = products && products.length > 0;
  // Helper to extract URL from various photo object formats
  const getPhotoUrl = (photo) => {
    if (!photo) return null;
    if (typeof photo === 'string') return photo;
    return photo.url || photo.googleUrl || photo.sourceUrl || photo.image || photo.imageUrl || photo.thumbnailUrl || null;
  };

  const hasPhotos = photos && photos.length > 0 && photos.some(p => getPhotoUrl(p));
  const hasTestimonials = testimonials && testimonials.length > 0;
  const hasContactInfo = contactInfo && (contactInfo.address || contactInfo.phone);
  const hasGMBFeed = gmbFeed && ((gmbFeed.posts && gmbFeed.posts.length > 0) || (Array.isArray(gmbFeed) && gmbFeed.length > 0));

  return (
    <>
      <GoogleFontsLink />
      <TemplateContainer>
        {hasBusinessInfo && (
          <NavigationHeader businessInfo={businessInfo} contactInfo={contactInfo} />
        )}

        {hasBusinessInfo && (
          <HeroSection
            businessInfo={businessInfo}
            heroImage={hasPhotos ? getPhotoUrl(photos[0]) : null}
            contactInfo={contactInfo}
          />
        )}

        {(hasServices || hasProducts) && (
          <ServicesSection
            services={services}
            products={products}
          />
        )}

        {hasBusinessInfo && (
          <AboutSection
            businessInfo={businessInfo}
            contactInfo={contactInfo}
          />
        )}

        {hasPhotos && (
          <PhotoGallery photos={photos} />
        )}

        {hasTestimonials && (
          <TestimonialsSection testimonials={testimonials} />
        )}

        {hasGMBFeed && (
          <GMBFeedSection gmbFeed={gmbFeed} />
        )}

        <BusinessHoursSection
          businessHours={businessHours}
          contactInfo={contactInfo}
        />

        {hasContactInfo && (
          <LocationSection
            location={location}
            contactInfo={contactInfo}
          />
        )}

        <CategoryTagsSection
          businessInfo={businessInfo}
          categories={categories}
          services={services}
          products={products}
          keywordsData={keywordsData}
        />

        <RelatedServicesSection
          businessInfo={businessInfo}
          contactInfo={contactInfo}
          categories={categories}
        />

        <Footer
          businessInfo={businessInfo}
          contactInfo={contactInfo}
        />
      </TemplateContainer>
    </>
  );
};

export default Template9;
